import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";

import WithLayout from "~franchise-website/WithLayout";
import Container from "~franchise-website/common/Container";
import { Fluid as FluidLayout } from "~franchise-website/layouts/Fluid";

import {
	Benefits,
	CallToAction,
	CaseStudyOne,
	CaseStudyTwo,
	Customers,
	Hero,
	Messaging,
	Process,
	Reviews,
} from "./components";

export const Franchise = () => {
	return (
		<WithLayout
			component={FranchiseApp}
			layout={FluidLayout}
		/>
	);
};

export const FranchiseApp = ({ themeMode }) => {
	const theme = useTheme();

	return (
		<Box>
			<Box
				marginTop={8}
				bgcolor={theme.palette.alternate.main}
				position="relative">
				<Container
					position="relative"
					zIndex={2}>
					<Hero />
				</Container>
				<Box
					component="svg"
					preserveAspectRatio="none"
					xmlns="http://www.w3.org/2000/svg"
					x="0px"
					y="0px"
					viewBox="0 0 1921 273"
					sx={{
						position: "absolute",
						width: "100%",
						left: 0,
						bottom: 0,
						right: 0,
						zIndex: 1,
						height: "35%",
					}}>
					<polygon
						fill={theme.palette.background.paper}
						points="0,273 1921,273 1921,0 "
					/>
				</Box>
			</Box>
			<Container>
				<Customers />
			</Container>
			<Container>
				<Benefits themeMode={themeMode} />
			</Container>
			<Box
				bgcolor={theme.palette.alternate.main}
				position="relative"
				marginBottom={12}>
				<Container paddingX={2}>
					<Grid
						item
						xs={12}
						md={12}>
						<video
							className="mobile-video"
							width="100%"
							height="678"
							controls>
							<source
								src="https://production-franchise-web-sto-assetsbucket5f3b285a-1vuwv4kiuw6q6.s3.amazonaws.com/Mango_Franchise_how_to_sell.mp4"
								type="video/mp4"
							/>
						</video>
					</Grid>
				</Container>
			</Box>
			<Container borderRadius={4}>
				<Process />
			</Container>
			<Container>
				<CaseStudyOne />
			</Container>
			<Box bgcolor={theme.palette.alternate.main}>
				<Container>
					<Reviews />
				</Container>
				<Container>
					<Messaging />
				</Container>
				<Container>
					<CaseStudyTwo />
				</Container>
				<Container id="cta">
					<CallToAction />
				</Container>
			</Box>
		</Box>
	);
};
